import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { pages } from 'src/app/alv-enums';
import * as tools from '../../tools';

@Component({
	selector: 'receipt',
	templateUrl: './receipt.component.html',
	styleUrls: ['./receipt.component.scss']
})
export class ReceiptComponent implements OnInit {
	@Output() private pageChange = new EventEmitter<pages>();

	/** This is here to allow the html code to access the pages enum. */
	public pagesEnum: any;

	public showReceiptOptions: boolean = false;
	public showProcessing: boolean = false;

	constructor(private dataService: DataService
		, public storeService: StoreService
		, private toolsService: ToolsService
	) {
		this.pagesEnum = pages;
	}

	async ngOnInit() {
		await this.printTicket();

		const showEmail = this.storeService.kioskSettings && this.storeService.kioskSettings.showEmail !== false;
		const paperReceiptDisabled = this.storeService.kioskSettings && this.storeService.kioskSettings.isDisablePaperReceipt === true;

		if (!showEmail && paperReceiptDisabled) {
			this.goToPage(pages.ThankYou);
			return;
		}

		this.showProcessing = true;

		if (showEmail) {
			await this.emailReceipt();
		}

		this.showReceiptOptions = false;

		if (paperReceiptDisabled) {
			this.showProcessing = false;
			this.goToPage(pages.ThankYou);
			return;
		}

		this.showProcessing = false;
		this.showReceiptOptions = true;
	}

	goToPage(page: pages) {
		this.pageChange.emit(page);
	}

	async print(printReceipt: boolean = true) {
		if (printReceipt) {
			await this.printReceipt();
		}
		this.goToPage(pages.ThankYou);
	}

	async printReceipt() {
		const postData = {
			transactionId: this.storeService.shoppingCart.transactionId,
			transactionSourceTypeId: this.storeService.shoppingCart.transactionSourceTypeId,
			timeZoneOffset: tools.getTimeZoneoffset(),
			registerId: this.storeService.shoppingCart.registerId
		};

		await this.dataService.post<any>(`/Checkout/PrintReceipt`, postData)
			.then(response => {
				this.toolsService.ProcessHttpResponse(response, () => {
					this.toolsService.showSuccess('Receipt printed');
				});
			})
			.catch(error => {
				this.toolsService.showError('Receipt failed to print');
			});
	}

	async printTicket() {

		const postData = {
			guestId: this.storeService.shoppingCart.guestId,
			transactionId: this.storeService.shoppingCart.transactionId,
			transactionSourceType: this.storeService.shoppingCart.transactionSourceType,
			transactionSourceTypeId: this.storeService.shoppingCart.transactionSourceTypeId,
			registerId: this.storeService.shoppingCart.registerId
		};

		await this.dataService.post<any>(`/Checkout/PrintTicket`, postData)
			.then(response => {

				this.toolsService.ProcessHttpResponse(response, () => {
					if (response.succeeded) {
						this.toolsService.showSuccess(response.message);
					} else {
						this.toolsService.showError(response.message);
					}
				});
			})
			.catch(error => {
				this.toolsService.showError('Ticket failed to print');
			});
	}

	async emailReceipt() {
		// this is a hack to skip email sending and needs to be better handled alongside changing the logic for hideInfostep. 
		// The issue with that is the email field is collected alongside that hence a bug where showEmail can be enabled and at the same not collect an email due to the hideInfoStep flag supercedes it
		// Fixing that now is not worth the trouble and we can just attribute not sending an email due to misconfiguration.
		if (!this.storeService.shoppingCart.guestEmail) {
			console.warn('Skipping email receipt: no guest email provided');
			return;
		}

		const postData = {
			guestEmail: this.storeService.shoppingCart.guestEmail,
			transactionId: this.storeService.shoppingCart.transactionId
		};

		await this.dataService.post<any>(`/Checkout/EmailReceipt`, postData)
			.then(response => {
				this.toolsService.ProcessHttpResponse(response, () => {
					this.toolsService.showSuccess('Receipt emailed');
				});
			})
			.catch(error => {
				this.toolsService.showError('Failed to send receipt email');
			});
	}

}
